export default __webpack_public_path__ + "static/media/health5.b3c7e68d.png";